(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-gf-article-detail]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const body = root.querySelector('.gf-article-detail__body');
      body.querySelectorAll('table').forEach(table => {
        if (table.parentElement.matches('.gf-table-scroll,.table-wrapper') || getComputedStyle(table.parentElement).overflowX === 'auto') return;
        const wrap = document.createElement('div'); wrap.className = 'gf-table-scroll'; table.before(wrap); wrap.append(table);
      });
      const toc = root.querySelector('.gf-article-toc');
      const existing = body.querySelector('nav[aria-label*="contents" i], [data-toc], .table-of-contents, #toc') || [...body.querySelectorAll('h2,h3')].some(h => /^(table of contents|contents)$/i.test(h.textContent.trim()) && h.nextElementSibling?.querySelector('a[href^="#"]'));
      const headings = [...body.querySelectorAll('h2')].filter(h => h.textContent.trim());
      if (existing || !headings.length) return;
      const list = toc.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) {
          const base = 'gf-section-' + (heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || (index + 1));
          let id = base, suffix = 2; while (document.getElementById(id)) id = base + '-' + suffix++;
          heading.id = id;
        }
        const li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + encodeURIComponent(heading.id); a.textContent = heading.textContent.trim();
        a.addEventListener('click', event => {
          event.preventDefault(); history.replaceState(null, '', a.hash);
          heading.scrollIntoView({block:'start', behavior:'instant'});
          if (!heading.hasAttribute('tabindex')) heading.tabIndex = -1;
          heading.focus({preventScroll:true});
        });
        li.append(a); list.append(li);
      });
      toc.hidden = false;
      const desktop = matchMedia('(min-width:1000px)');
      const adjust = () => { toc.open = desktop.matches; };
      adjust(); desktop.addEventListener('change', adjust);
    });
    scope.querySelectorAll('[data-gf-article-tools]').forEach(tools => {
      if (tools.dataset.initialized) return; tools.dataset.initialized = 'true';
      const canonical = document.querySelector('link[rel="canonical"]')?.href || tools.dataset.canonical;
      const encoded = encodeURIComponent(canonical), title = encodeURIComponent(tools.dataset.title);
      tools.querySelector('[data-share="facebook"]').href = 'https://www.facebook.com/sharer/sharer.php?u=' + encoded;
      tools.querySelector('[data-share="linkedin"]').href = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encoded;
      tools.querySelector('[data-share="x"]').href = 'https://twitter.com/intent/tweet?url=' + encoded + '&text=' + title;
      tools.querySelector('[data-copy-url]').addEventListener('click', async () => {
        const status = tools.querySelector('[role="status"]'), input = tools.querySelector('input');
        try { if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable'); await navigator.clipboard.writeText(canonical); input.hidden = true; status.textContent = tools.dataset.copied; }
        catch { input.hidden = false; input.value = canonical; input.focus(); input.select(); status.textContent = tools.dataset.fallback; }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
